import { render } from "./NewModal.vue?vue&type=template&id=669e6d04&scoped=true&ts=true"
import script from "./NewModal.vue?vue&type=script&lang=ts"
export * from "./NewModal.vue?vue&type=script&lang=ts"

import "./NewModal.vue?vue&type=style&index=0&id=669e6d04&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669e6d04"]])

export default __exports__